import React, { useState } from 'react';

export const TabComponent = ({ onTabChange }) => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    onTabChange(tab);
  };

  return (
    <div className="flex rounded-lg pb-12">
      <button
        className={`flex justify-center items-center gap-2 px-4 py-2.5 rounded-l-lg border ${
          activeTab === 'upcoming'
            ? 'bg-[#DCEEFA] border-[#006EB7] text-[#006EB7] font-semibold'
            : 'border-[#CBCDD6] text-[#5B5D6B] font-semibold'
        }`}
        onClick={() => handleTabClick('upcoming')}
      >
        Upcoming
      </button>
      <button
        className={`flex justify-center items-center gap-2 px-4 py-2.5 rounded-r-lg border ${
          activeTab === 'pastEvents'
            ? 'bg-[#DCEEFA] border-[#006EB7] text-[#006EB7] font-semibold'
            : 'border-[#CBCDD6] text-[#5B5D6B] font-semibold'
        }`}
        onClick={() => handleTabClick('pastEvents')}
      >
        Past events
      </button>
    </div>
  );
};
